<template>
  <itisBackTop v-bind="$attrs" @handle-click="handleCLick">
    <div class="line-logo">
      <img src="../../../../assets/index/line-logo.png" alt="" />
    </div>
  </itisBackTop>
</template>

<script setup lang="ts" name="itisBackTop">
import itisBackTop from "@/distributions/consumer/y/views/index/components/IndexBackToTop.vue";

const handleCLick = () => {
  window.open("https://line.me/R/ti/p/%40luxuryitis", "_blank");
};
</script>

<style lang="scss" scoped>
:deep() {
  .el-backtop {
    width: 60px;
    height: 60px;
  }
  .prevent {
    width: 60px;
    height: 60px;
    z-index: 10;
  }
}

.line-logo {
  width: 60px;
  height: 60px;
  z-index: 5;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
